import { useMemo } from "react";
import { Modal, Table } from "antd";
import { useSelector } from "react-redux";
import { getAuthToken } from "Helper/AuthTokenHelper";
import { formatDateToDDMMYYYY } from "utils/CommonFunctions";

const columns = [
  {
    title: "Sr. No.",
    dataIndex: "sr_no",
    key: "sr_no",
  },
  {
    title: "In Year",
    dataIndex: "in_year",
    key: "in_year",
  },
  {
    title: "Pregnancy Outcome",
    dataIndex: "pregnancy_outcome",
    key: "pregnancy_outcome",
  },
  {
    title: "With Partner",
    dataIndex: "with_partner",
    key: "with_partner",
  },
  {
    title: "Delivery Method",
    dataIndex: "delivery_method",
    key: "delivery_method",
  },
  {
    title: "PG Week",
    dataIndex: "pg_week",
    key: "pg_week",
  },
  {
    title: "Child Died Perinatally",
    dataIndex: "child_died_perinatally",
    key: "child_died_perinatally",
  },
  {
    title: "Type of Conception",
    dataIndex: "type_of_conception",
    key: "type_of_conception",
  },
  {
    title: "Note",
    dataIndex: "note",
    key: "note",
  },
];

const PatientBasicHistoryModal = ({ isOpen, onClose }) => {
  const userData = getAuthToken();

  const theme = localStorage.getItem("default-theme");

  const { activePatientJourneyModuleDetails } = useSelector(
    ({ dashboard }) => dashboard
  );

  const previousPregnanciesDetails = useMemo(() => {
    return (
      activePatientJourneyModuleDetails?.preganancyData?.map((item, i) => {
        return {
          ...item,
          isDelete: userData?.other === false ? true : false,
          sr_no: i + 1,
        };
      }) || []
    );
  }, [activePatientJourneyModuleDetails?.preganancyData, userData?.other]);

  return (
    <>
      <Modal
        centered
        open={isOpen}
        title="Patient Basic History Detail"
        className={`patient-registration-modal theme-${theme}`}
        maskClosable={false}
        onCancel={() => {
          onClose();
        }}
        width={860}
      >
        <div className="modal-details">
          <div className="modal-content-details">
            <div className="details">
              <div className="details-table">
                <div>Patient ID</div>
                <div>{activePatientJourneyModuleDetails?.patient_id}</div>
                <div>Patient Name</div>
                <div>
                  {activePatientJourneyModuleDetails?.patient_full_name}
                </div>
                <div>Attending Dr.</div>
                <div>{activePatientJourneyModuleDetails?.attending_dr}</div>
                <div>Blood Group</div>
                <div>
                  {activePatientJourneyModuleDetails?.patient_blood_group}
                </div>
                <div>Partner Age</div>
                <div>{activePatientJourneyModuleDetails?.partner_age}</div>
                <div>Date Of Birth</div>
                <div>
                  {activePatientJourneyModuleDetails?.patient_dob
                    ? formatDateToDDMMYYYY(
                        activePatientJourneyModuleDetails?.patient_dob
                      )
                    : ""}
                </div>
              </div>
            </div>
            <div className="details">
              <div className="table-title">
                Basic Information (Donor - Male)
              </div>
              <div className="details-table">
                <div>Height (cm)</div>
                <div>{activePatientJourneyModuleDetails?.height}</div>
                <div>Weight (kg)</div>
                <div>{activePatientJourneyModuleDetails?.weight}</div>
                <div>Donor Information</div>
                <div>{activePatientJourneyModuleDetails?.donor_info}</div>
                <div>BMI</div>
                <div>{activePatientJourneyModuleDetails?.bmi}</div>
                <div>Count (ml)</div>
                <div>{activePatientJourneyModuleDetails?.count_per_ml}</div>
                <div>Agglutation</div>
                <div>{activePatientJourneyModuleDetails?.agglutation}</div>
                <div>Motility %</div>
                <div>{activePatientJourneyModuleDetails?.motility_percent}</div>
                <div>WBCs</div>
                <div>{activePatientJourneyModuleDetails?.wbc}</div>
                <div>RBCs</div>
                <div>{activePatientJourneyModuleDetails?.rbc}</div>
                <div>Quantity</div>
                <div>{activePatientJourneyModuleDetails?.quantity}</div>
                <div>Facial Feature</div>
                <div>{activePatientJourneyModuleDetails?.facial_feature}</div>
                <div>Health Looks</div>
                <div>{activePatientJourneyModuleDetails?.health_looks}</div>
                <div>Color of Hair</div>
                <div>{activePatientJourneyModuleDetails?.colour_of_hair}</div>
                <div>Color of Eye</div>
                <div>{activePatientJourneyModuleDetails?.colour_of_eyes}</div>
                <div>Skin Tone</div>
                <div>{activePatientJourneyModuleDetails?.colour_of_skin}</div>
                <div>Habits</div>
                <div>{activePatientJourneyModuleDetails?.habits}</div>
                <div>Education Qualification</div>
                <div>
                  {activePatientJourneyModuleDetails?.education_qualification}
                </div>
                <div>Any Genetically Acquired Disease</div>
                <div>
                  {
                    activePatientJourneyModuleDetails?.genetically_acquired_disease
                  }
                </div>
                <div>History of any Chronic Illness</div>
                <div>{activePatientJourneyModuleDetails?.chronic_illness}</div>
                <div>Serious Disease to any close blood relative</div>
                <div>
                  {activePatientJourneyModuleDetails?.disease_to_blood_relative}
                </div>
                <div>Any Congenital Deformities</div>
                <div>
                  {activePatientJourneyModuleDetails?.congenital_deformities}
                </div>
                <div>Serious Disease to any family member</div>
                <div>
                  {activePatientJourneyModuleDetails?.disease_to_family_member}
                </div>
                <div>Note</div>
                <div>
                  {activePatientJourneyModuleDetails?.donor_info?.notes}
                </div>
              </div>
            </div>

            {/*  </div>
      <div className='col-lg-6'>
           
          </div> */}
            <div className="details">
              <div className="table-title">
                Basic Information (Donor - Female)
              </div>
              <div className="details-table">
                <div>Marital status</div>
                <div>{activePatientJourneyModuleDetails?.marital_status}</div>
                <div>Religion</div>
                <div>{activePatientJourneyModuleDetails?.religion}</div>
                <div>Subcast</div>
                <div>{activePatientJourneyModuleDetails?.sub_cast}</div>
              </div>
            </div>
            <div className="details">
              <div className="table-title">
                Obstetric History (Donor - Female)
              </div>
              <div className="details-table">
                <div>Extra Uterine</div>
                <div>{activePatientJourneyModuleDetails?.extra_uterine}</div>
                <div>Number Living Child</div>
                <div>{activePatientJourneyModuleDetails?.living_child}</div>
                <div>Gravida</div>
                <div>{activePatientJourneyModuleDetails?.gravida}</div>
                <div>Para</div>
                <div>{activePatientJourneyModuleDetails?.para}</div>
              </div>
            </div>
            <div className="details">
              <div className="table-title">Education (Donor - Female)</div>
              <div className="details-table">
                <div>Donor Education</div>
                <div>{activePatientJourneyModuleDetails?.donor_education}</div>
                <div>Spouse Education</div>
                <div>{activePatientJourneyModuleDetails?.spouse_education}</div>
              </div>
            </div>
            <div className="details">
              <div className="table-title">Occupation (Donor - Female)</div>
              <div className="details-table">
                <div>Donor Occupation</div>
                <div>{activePatientJourneyModuleDetails?.donor_occupation}</div>
                <div>Spouse Occupation</div>
                <div>
                  {activePatientJourneyModuleDetails?.spouse_occupation}
                </div>
                <div>Monthly Income (INR)</div>
                <div>{activePatientJourneyModuleDetails?.monthly_income}</div>
              </div>
            </div>
            <div className="details">
              <div className="table-title">History (Donor - Female)</div>
              <div className="details-table">
                <div>Number of deliveries</div>
                <div>{activePatientJourneyModuleDetails?.no_of_deliveries}</div>
                <div>Number of abortions</div>
                <div>{activePatientJourneyModuleDetails?.no_of_abortion}</div>
                <div>Other points of note</div>
                <div>{activePatientJourneyModuleDetails?.points_of_note}</div>
                <div>History of use of contraceptives</div>
                <div>
                  {activePatientJourneyModuleDetails?.use_of_contraceptives}
                </div>
                <div>Medical history</div>
                <div>{activePatientJourneyModuleDetails?.medical_history}</div>
                <div>History of any abnormality in a child of donor</div>
                <div>
                  {activePatientJourneyModuleDetails?.abnoramility_in_child}
                </div>
                <div>History of blood transfusion</div>
                <div>
                  {activePatientJourneyModuleDetails?.blood_transfusion}
                </div>
                <div>History of substance abuse</div>
                <div>{activePatientJourneyModuleDetails?.substance_abuse}</div>
              </div>
            </div>
            <div className="details">
              <div className="table-title">
                Menstrual History (Donor - Female)
              </div>
              <div className="details-table">
                <div>Regularity</div>
                <div>{activePatientJourneyModuleDetails?.regularity}</div>
                <div>Duration (Days)</div>
                <div>{activePatientJourneyModuleDetails?.duration}</div>
                <div>Distance (Days)</div>
                <div>{activePatientJourneyModuleDetails?.distance}</div>
                <div>Intensity</div>
                <div>{activePatientJourneyModuleDetails?.intensity}</div>
              </div>
            </div>
            <div className="details">
              <div className="table-title">Features (Donor - Female)</div>
              <div className="details-table">
                <div>Height</div>
                <div>{activePatientJourneyModuleDetails?.height}</div>
                <div>Weight (KG)</div>
                <div>{activePatientJourneyModuleDetails?.weight}</div>
                <div>Colour of skin</div>
                <div>{activePatientJourneyModuleDetails?.colour_of_skin}</div>
                <div>Colour of hair</div>
                <div>{activePatientJourneyModuleDetails?.colour_of_hair}</div>
                <div>Colour of eyes</div>
                <div>{activePatientJourneyModuleDetails?.colour_of_eyes}</div>
              </div>
            </div>
            <div className="details">
              <div className="table-title">
                Detailed physical examination (Donor - Female)
              </div>
              <div className="details-table">
                <div>Pulse (Per Min)</div>
                <div>{activePatientJourneyModuleDetails?.pulse}</div>
                <div>Blood pressure (mmHg)</div>
                <div>{activePatientJourneyModuleDetails?.blood_pressure}</div>
                <div>Temperature (F)</div>
                <div>{activePatientJourneyModuleDetails?.temperature}</div>
                <div>Respiratory system AEBE Clear</div>
                <div>
                  {activePatientJourneyModuleDetails?.respiratory_aebe_clear}
                </div>
              </div>
            </div>
            <div className="details">
              <div className="table-title">
                Cardiovascular system (Donor - Female)
              </div>
              <div className="details-table">
                <div>Murmur</div>
                <div>{activePatientJourneyModuleDetails?.murmur}</div>
                <div>S1 S2</div>
                <div>{activePatientJourneyModuleDetails?.s1s2}</div>
                <div>Per abdominal examination</div>
                <div>
                  {activePatientJourneyModuleDetails?.abdominal_examination}
                </div>
                <div>No Organomegaly</div>
                <div>{activePatientJourneyModuleDetails?.organomegaly}</div>
                <div>Notes</div>
                <div>{activePatientJourneyModuleDetails?.notes}</div>
              </div>
            </div>
            <div className="details">
              <div className="table-title">Basic Information</div>
              <div className="details-table">
                <div>Height (cm)</div>
                <div>{activePatientJourneyModuleDetails?.height}</div>
                <div>Weight (kg)</div>
                <div>{activePatientJourneyModuleDetails?.weight}</div>
                <div>BMI</div>
                <div>{activePatientJourneyModuleDetails?.bmi}</div>
                <div>Date of Medical History</div>
                <div>
                  {activePatientJourneyModuleDetails?.date_of_medical_history}
                </div>
                <div>Patency of the Fallopian Tube (Right)</div>
                <div>
                  {
                    activePatientJourneyModuleDetails?.patency_of_the_fallopian_tube_right
                  }
                </div>
                <div>Patency of the Fallopian Tube (Left)</div>
                <div>
                  {
                    activePatientJourneyModuleDetails?.patency_of_the_fallopian_tube_left
                  }
                </div>
                <div>Chromosome Analysis</div>
                <div>
                  {activePatientJourneyModuleDetails?.chromosome_analysis}
                </div>
                <div>Karyotype</div>
                <div>{activePatientJourneyModuleDetails?.karyotype}</div>
                <div>Fallopian Tube Reviewed (Yr)</div>
                <div>
                  {activePatientJourneyModuleDetails?.fallopian_tube_reviewed}
                </div>
                <div>No. of Previous OT</div>
                <div>
                  {activePatientJourneyModuleDetails?.no_of_previous_ot}
                </div>
              </div>
            </div>
            <div className="details">
              <div className="table-title">Obstetric History</div>
              <div className="details-table">
                <div>Extra Uterine</div>
                <div>{activePatientJourneyModuleDetails?.extra_uterine}</div>
                <div>Number Living Child</div>
                <div>{activePatientJourneyModuleDetails?.living_child}</div>
                <div>Gravida</div>
                <div>{activePatientJourneyModuleDetails?.gravida}</div>
                <div>Para</div>
                <div>{activePatientJourneyModuleDetails?.para}</div>
              </div>
            </div>
            {/* <div className="details">
              <div className="table-title">Previous Pregnancies</div>
              <div className="details-table">
                <div>Sr. No.</div>
                <div>{activePatientJourneyModuleDetails?.sr_no}</div>
                <div>In Year</div>
                <div>{activePatientJourneyModuleDetails?.in_year}</div>
                <div>Pregnancy Outcome</div>
                <div>
                  {activePatientJourneyModuleDetails?.pregnancy_outcome}
                </div>
                <div>With Partner</div>
                <div>{activePatientJourneyModuleDetails?.with_partner}</div>
                <div>Delivery Method</div>
                <div>{activePatientJourneyModuleDetails?.delivery_method}</div>
                <div>PG Week</div>
                <div>{activePatientJourneyModuleDetails?.pg_week}</div>
                <div>Child Died Perinatally</div>
                <div>
                  {activePatientJourneyModuleDetails?.child_died_perinatally}
                </div>
                <div>Type of Conception</div>
                <div>
                  {activePatientJourneyModuleDetails?.type_of_conception}
                </div>
                <div>Note</div>
                <div>{activePatientJourneyModuleDetails?.note}</div>
              </div>
            </div> */}
            <div className="details">
              <div className="table-title">Previous Treatment</div>
              <div className="details-table">
                <div>No. of Previous OT</div>
                <div>
                  {activePatientJourneyModuleDetails?.no_of_previous_ot}
                </div>
                <div>No. of IUI</div>
                <div>{activePatientJourneyModuleDetails?.no_of_iui}</div>
                <div>FET</div>
                <div>{activePatientJourneyModuleDetails?.fet}</div>
                <div>IVF / ICSI</div>
                <div>{activePatientJourneyModuleDetails?.ivf_icsi}</div>
                <div>IUID</div>
                <div>{activePatientJourneyModuleDetails?.iuid}</div>
                <div>Freeze All</div>
                <div>{activePatientJourneyModuleDetails?.freeze_all}</div>
                <div>OD</div>
                <div>{activePatientJourneyModuleDetails?.od}</div>
                <div>ED</div>
                <div>{activePatientJourneyModuleDetails?.ed}</div>
                <div>PGT</div>
                <div>{activePatientJourneyModuleDetails?.pgt}</div>
                <div>Surrogacy</div>
                <div>{activePatientJourneyModuleDetails?.surrogacy}</div>
              </div>
            </div>
            <div className="details">
              <div className="table-title">Other Details</div>
              <div className="details-table">
                <div>Previous Illnesses</div>
                <div>
                  {activePatientJourneyModuleDetails?.previous_illnesses}
                </div>
                <div>Sterility Factors</div>
                <div>
                  {activePatientJourneyModuleDetails?.sterility_factors}
                </div>
                <div>Notes</div>
                <div>{activePatientJourneyModuleDetails?.notes}</div>
              </div>
            </div>
          </div>
          <div className="cmn_table_wrap table_wrapper mb-2">
            <div className="table-title">Previous Pregnancies</div>

            <Table
              columns={columns}
              dataSource={previousPregnanciesDetails}
              pagination={false}
            />
          </div>
        </div>
      </Modal>
    </>
  );
};

export default PatientBasicHistoryModal;
